import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import {
  payloadAgentProfile,
  payloadAgentsList,
  payloadDescendantAgents,
  payloadPlayersList,
  payloadPlayersOptions,
  payloadPlayerWalletIdentities,
  payloadRoles,
  payloadStartBranch,
  payloadUpdateAgentProfile,
  payloadWalletIdentities,
  WalletItemType,
  payloadPlayerProfile,
  payloadUpdateAgentRole, payloadCashierAdmin,
} from "../../store/admin/cashier";

const getList = (data: payloadAgentsList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

// ???
const getFullList = (data: payloadAgentsList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.fullList;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBrandsList = (data: payloadAgentsList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.conditions.brands_list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getWallets = () => {

  const endpoint = api.admin.cashier.walletList;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createBranch = (data: payloadStartBranch) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.startBranch;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}

const getDescendantAgents = (data: payloadDescendantAgents) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.descendantAgents;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFullAgentsOptions = (data: payloadDescendantAgents) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.fullAgentsList;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getRoles = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.cashier.roles}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getWalletIdentities = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.cashier.walletIdentities}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.createAgent;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const enableWallet = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.enableWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const disableWallet = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.disableWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const addWallet = (data: WalletItemType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.addWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAgentBalanceById = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.getAgentBalance.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerList = (data: payloadPlayersList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.playerList;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFullPlayerList = (data: payloadPlayersList) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.fullPlayerList;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerBalanceById = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.agents.getPlayerBalance.replace('{playerId}', `${data.playerId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setTransferToAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.transferToAgent.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setTransferAllToAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transferAllToAgent.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayersOptions = (data: payloadPlayersOptions) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.players;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerWalletIdentities = (data: payloadPlayerWalletIdentities) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.agents.playerWalletIdentities.replace('{playerId}', `${data.playerId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setTransferToPlayer = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.transferToPlayer.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAgentProfile = (data: payloadAgentProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.agentProfile.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateAgentProfile = (data: payloadUpdateAgentProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.updateAgentProfile.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerProfile = (data: payloadPlayerProfile) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.playerProfile.replace('{playerId}', `${data.playerId}`);

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateAgentRole = (data: payloadUpdateAgentRole) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.updateAgentRole.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFilterRoles = () => {
  const endpoint = api.admin.cashier.filter_roles;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFilterRolesAll = () => {
	const endpoint = api.admin.agents.filter_roles_all;

	return fetch(
		`${endpoint}`,
		{...RequestOptions('GET')}
	)
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

const toggleBlockAgent = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.toggleBlockAgent
    .replace('{agentId}', `${data.agentId}`)
    .replace('{statusBlock}', `${data.status === 'blocked' ? 'unblock' : 'block'}`);

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setAgentNewPassword = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.agentNewPassword.replace('{agentId}', `${data.agentId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PATCH', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBetListFilters = () => {
  const endpoint = api.admin.agents.betListFilters;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCasinoBetListFilters = () => {
  const endpoint = api.admin.agents.casinoBetListFilters;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const toggleBlockPlayer = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.toggleBlockPlayer
    .replace('{playerId}', `${data.playerId}`)
    .replace('{statusBlock}', `${data.status === 'blocked' ? 'unblock' : 'block'}`);

  const payload = {
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getPlayerStatus = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.getPlayerStatus
    .replace('{playerId}', `${data.playerId}`);

  const payload = {
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setPlayerNewPassword = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.playerNewPassword.replace('{playerId}', `${data.playerId}`);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('PUT', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createPlayer = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.agents.createPlayer;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getAdminBalanceUpdate = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.updateAdminBalance;

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCashierWalletIdentities = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.cashier.cashierWalletIdentities.replace('{cashierId}', `${data.id}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getCashierAdminOptions = (data: payloadCashierAdmin) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.cashier.cashierAdminOptions;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const agentsService = {
  getList,
  getFullList,
  getBrandsList,
  getWallets,
  enableWallet,
  disableWallet,
  addWallet,
  createBranch,
  getDescendantAgents,
  getRoles,
  getWalletIdentities,
  createAgent,
  getAgentBalanceById,
  getPlayerList,
  getPlayerBalanceById,
  setTransferToAgent,
  getPlayersOptions,
  getPlayerWalletIdentities,
  setTransferToPlayer,
  getFullAgentsOptions,
  setTransferAllToAgent,
  getFullPlayerList,
  getAgentProfile,
  updateAgentProfile,
  getPlayerProfile,
  updateAgentRole,
  getFilterRoles,
  getFilterRolesAll,
  toggleBlockAgent,
  setAgentNewPassword,
  getBetListFilters,
  getCasinoBetListFilters,
  toggleBlockPlayer,
  getPlayerStatus,
  setPlayerNewPassword,
  createPlayer,
  getAdminBalanceUpdate,
  getCashierWalletIdentities,
  getCashierAdminOptions,
};
